import { PipesModule } from './../../pipes/pipes.module';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CommonComponentsModule } from './../common/common.module';
import { NgModule } from '@angular/core';
import { HomeComponent } from './home.component';
import { routing } from './home.routing';
import { ProductsComponent } from '@app/components/products/products.component';
import { MenusComponent } from '@app/components/menus/menus.component';
import { FormsModule } from '@angular/forms';
@NgModule({
    imports: [
        CommonComponentsModule,
        RouterModule,
        routing,
        CommonModule,
        PipesModule,
        FormsModule
    ],
    declarations: [
        HomeComponent,
        ProductsComponent,
        MenusComponent
    ],
    exports: [
    ]
})

export class HomeModule {

}
